import { Result } from "src/utils/Result"
import { restoreTrashedMail } from "src/aws/customAPI"
import { execApi } from "src/apis/execApi"
import { appInfo } from "src/constants/AppInfo"

type RestoreContactParams = {
  accessToken: string
  myMemberId: string
  contactId: string
}

type RestoreContactSuccess = unknown

type RestoreContactFailure = {
  message: string
}

export const restoreContact = async (params: RestoreContactParams): Promise<Result<RestoreContactSuccess, RestoreContactFailure>> => {
  const {accessToken, myMemberId, contactId} = params

  return execApi(
    () => restoreTrashedMail(accessToken, {
      input: {
        memberId: myMemberId,
        mailId: contactId
      },
      appInfo
    }),
    _ => undefined,
    {
      identifiers: ["restoreContact", "restoreTrashedMail"],
      defaultErrorMessage: "ゴミ箱からの復元に失敗しました"
    }
  )
}
